import { FilterConfig, FilterType } from '@sm-dashboard/types';
import { BusinessAd } from './businessAdsUtils';
import { CATEGORIES_WITH_SUBCATEGORIES, TARGET_AUDIENCES, LOCATIONS } from '@/constants/businessAds.constants';
import { getToday, getOneYearAgo } from '@sm-dashboard/grid-data';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

export const useBusinessAdsFilters = () => {
  const [searchParams] = useSearchParams();
  const selectedCategory = searchParams.get('category') || '';

  const filters: FilterConfig<BusinessAd>[] = useMemo(() => {
    // Get available subcategories based on selected category
    const categoryData = CATEGORIES_WITH_SUBCATEGORIES.find(cat => cat.name === selectedCategory);
    const availableSubcategories = categoryData ? categoryData.subcategories : [];

    return [
    {
      field: 'searchTerm',
      label: 'חיפוש',
      type: 'text' as FilterType,
      show: true,
      level: 'primary'
    },
    {
      field: 'startDate',
      label: 'מתאריך',
      type: 'date' as FilterType,
      defaultValue: getOneYearAgo(),
      show: true
    },
    {
      field: 'endDate',
      label: 'עד תאריך',
      type: 'date' as const,
      defaultValue: getToday(),
      show: true
    },
    {
      field: 'category',
      label: 'קטגוריה',
      type: 'select' as FilterType,
      options: CATEGORIES_WITH_SUBCATEGORIES.map(category => ({
          value: category.name,
          label: category.name
        })),
      show: true
    },
    {
      field: 'subCategory',
      label: 'תת קטגוריה',
      type: 'select' as FilterType,
      options: availableSubcategories.map(subcategory => ({
          value: subcategory,
          label: subcategory
        })),
      show: true
    },
    {
      field: 'targetAudience',
      label: 'קהל יעד',
      type: 'multiSelect' as FilterType,
      options: TARGET_AUDIENCES.map(audience => ({
        value: audience,
        label: audience
      })),
      show: true
    },
    {
      field: 'location',
      label: 'מיקום',
      type: 'multiSelect' as FilterType,
      options: LOCATIONS.map(location => ({
        value: location,
        label: location
      })),
      show: true
    }
  ];
  }, [selectedCategory]);

  return filters;
};


export const useAdminBusinessAdsFilters = () => {
    const [searchParams] = useSearchParams();
    const selectedCategory = searchParams.get('category') || '';
  
    const filters: FilterConfig<BusinessAd>[] = useMemo(() => {
      // Get available subcategories based on selected category
      const categoryData = CATEGORIES_WITH_SUBCATEGORIES.find(cat => cat.name === selectedCategory);
      const availableSubcategories = categoryData ? categoryData.subcategories : [];
  
      return [
      {
        field: 'searchTerm',
        label: 'חיפוש',
        type: 'text' as FilterType,
        show: true,
        level: 'primary'
      },
      {
        field: 'startDate',
        label: 'מתאריך',
        type: 'date' as FilterType,
        defaultValue: getOneYearAgo(),
        show: true
      },
      {
        field: 'endDate',
        label: 'עד תאריך',
        type: 'date' as const,
        defaultValue: getToday(),
        show: true
      },
      {
        field: 'category',
        label: 'קטגוריה',
        type: 'select' as FilterType,
        options: CATEGORIES_WITH_SUBCATEGORIES.map(category => ({
            value: category.name,
            label: category.name
          })),
        show: true
      },
      {
        field: 'subCategory',
        label: 'תת קטגוריה',
        type: 'select' as FilterType,
        options: availableSubcategories.map(subcategory => ({
            value: subcategory,
            label: subcategory
          })),
        show: true
      },
      {
        field: 'targetAudience',
        label: 'קהל יעד',
        type: 'multiSelect' as FilterType,
        options: TARGET_AUDIENCES.map(audience => ({
          value: audience,
          label: audience
        })),
        show: true
      },
      {
        field: 'location',
        label: 'מיקום',
        type: 'multiSelect' as FilterType,
        options: LOCATIONS.map(location => ({
          value: location,
          label: location
        })),
        show: true
      },
      {
        field: 'status',
        label: 'סטטוס',
        type: 'select' as FilterType,
        options: ['pending', 'approved', 'rejected'].map(status => ({
          value: status,
          label: mapStatusToLabel(status)
        })),
        show: true
      },
      {
        field: 'submitterType',
        label: 'סוג מפרסם',
        type: 'select' as FilterType,
        options: ['publisher', 'shaliach'].map(submitterType => ({
          value: submitterType,
          label: mapSubmitterType(submitterType)
        })),
        show: true
      }
    ];
    }, [selectedCategory]);
  
    return filters;
  };
  
  const mapSubmitterType = (submitterType: string) => {
    switch (submitterType) {
      case 'publisher':
        return 'מפרסם';
      case 'shaliach':
        return 'שליח';
      default:
        return submitterType;
    }
  };

  const mapStatusToLabel = (status: string) => {
    switch (status) {
      case 'pending':
        return 'ממתין';
      case 'approved':
        return 'אישור';
      case 'rejected':
        return 'דחייה';
      default:
        return status;
    }
  };